import {ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy} from '@angular/router';
import {isDefined} from '@webmate-web-core/shared/utils/utils';
import { Injectable } from "@angular/core";


@Injectable()
export class TestRouteReuseStrategy implements RouteReuseStrategy {

    storedRouteHandles = new Map<string, DetachedRouteHandle>();
    routesToCache = ['tests'];

    shouldReuseRoute(before: ActivatedRouteSnapshot, curr:  ActivatedRouteSnapshot): boolean {
        return before.routeConfig === curr.routeConfig;
    }

    retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
        return this.storedRouteHandles.get(`${this.getPath(route)}:${this.getProjectIdFromPath(route)}`) as DetachedRouteHandle;
    }

    shouldAttach(route: ActivatedRouteSnapshot): boolean {
        const path = this.getPath(route);
        if (this.routesToCache.indexOf(path) !== -1) {
            return this.storedRouteHandles.has(`${this.getPath(route)}:${this.getProjectIdFromPath(route)}`);
        }
        return false;
    }

    shouldDetach(route: ActivatedRouteSnapshot): boolean {
        const path = this.getPath(route);
        if (this.routesToCache.indexOf(path) !== -1) {
            return true;
        }
        return false;
    }

    store(route: ActivatedRouteSnapshot, detachedTree: DetachedRouteHandle): void {
        this.storedRouteHandles.set(`${this.getPath(route)}:${this.getProjectIdFromPath(route)}`, detachedTree);
    }

    private getPath(route: ActivatedRouteSnapshot): string {
        if (route.routeConfig !== null && route.routeConfig.path !== null) {
            return route.routeConfig.path;
        }
        return '';
    }

    private getProjectIdFromPath(route: ActivatedRouteSnapshot): string {
        let pid = route.pathFromRoot.find(a => a.paramMap.has("projectId"))
        return isDefined(pid) ? pid.paramMap.get("projectId") : undefined;
    }
}
